/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      id
      userCognitoSub
      userFirst
      userLast
      email
      phone1
      phone2
      address1
      address2
      address3
      City
      state
      zip
      zip4
      country
      activeUser
      premiumUser
      regInitialized
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      userCognitoSub
      userFirst
      userLast
      email
      phone1
      phone2
      address1
      address2
      address3
      City
      state
      zip
      zip4
      country
      activeUser
      premiumUser
      regInitialized
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModeluserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      userCognitoSub
      userFirst
      userLast
      email
      phone1
      phone2
      address1
      address2
      address3
      City
      state
      zip
      zip4
      country
      activeUser
      premiumUser
      regInitialized
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createHeatingUnit = /* GraphQL */ `
  mutation CreateHeatingUnit(
    $input: CreateHeatingUnitInput!
    $condition: ModelheatingUnitConditionInput
  ) {
    createHeatingUnit(input: $input, condition: $condition) {
      id
      unitEmail
      unitPhone
      unitAddress1
      unitAddress2
      unitAddress3
      unitCity
      unitState
      unitZip
      unitZip4
      unitCountry
      unitCapacity
      usageFactor
      sumDegreeDays
      sumFeelsLikeDays
      hotWater
      estRemainingCapacity
      estRemainingPercentage
      huLastUpdate
      activeUnit
      autoOrder
      autoOrderVendor
      preferredVendor
      vendorOwned
      owningVendor
      userOwned
      owningUser
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateHeatingUnit = /* GraphQL */ `
  mutation UpdateHeatingUnit(
    $input: UpdateHeatingUnitInput!
    $condition: ModelheatingUnitConditionInput
  ) {
    updateHeatingUnit(input: $input, condition: $condition) {
      id
      unitEmail
      unitPhone
      unitAddress1
      unitAddress2
      unitAddress3
      unitCity
      unitState
      unitZip
      unitZip4
      unitCountry
      unitCapacity
      usageFactor
      sumDegreeDays
      sumFeelsLikeDays
      hotWater
      estRemainingCapacity
      estRemainingPercentage
      huLastUpdate
      activeUnit
      autoOrder
      autoOrderVendor
      preferredVendor
      vendorOwned
      owningVendor
      userOwned
      owningUser
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteHeatingUnit = /* GraphQL */ `
  mutation DeleteHeatingUnit(
    $input: DeleteHeatingUnitInput!
    $condition: ModelheatingUnitConditionInput
  ) {
    deleteHeatingUnit(input: $input, condition: $condition) {
      id
      unitEmail
      unitPhone
      unitAddress1
      unitAddress2
      unitAddress3
      unitCity
      unitState
      unitZip
      unitZip4
      unitCountry
      unitCapacity
      usageFactor
      sumDegreeDays
      sumFeelsLikeDays
      hotWater
      estRemainingCapacity
      estRemainingPercentage
      huLastUpdate
      activeUnit
      autoOrder
      autoOrderVendor
      preferredVendor
      vendorOwned
      owningVendor
      userOwned
      owningUser
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createOilVendor = /* GraphQL */ `
  mutation CreateOilVendor(
    $input: CreateOilVendorInput!
    $condition: ModeloilVendorConditionInput
  ) {
    createOilVendor(input: $input, condition: $condition) {
      id
      vendorCognitoSub
      vendorFirst1
      vendorFirst2
      vendorLast1
      vendorLast2
      vendorEmail1
      vendorEmail2
      vendorPhone1
      vendorPhone2
      vendorAddress1
      vendorAddress2
      vendorAddress3
      vendorCity
      vendorState
      vendorZip
      vendorZip4
      unitCountry
      premiumVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateOilVendor = /* GraphQL */ `
  mutation UpdateOilVendor(
    $input: UpdateOilVendorInput!
    $condition: ModeloilVendorConditionInput
  ) {
    updateOilVendor(input: $input, condition: $condition) {
      id
      vendorCognitoSub
      vendorFirst1
      vendorFirst2
      vendorLast1
      vendorLast2
      vendorEmail1
      vendorEmail2
      vendorPhone1
      vendorPhone2
      vendorAddress1
      vendorAddress2
      vendorAddress3
      vendorCity
      vendorState
      vendorZip
      vendorZip4
      unitCountry
      premiumVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteOilVendor = /* GraphQL */ `
  mutation DeleteOilVendor(
    $input: DeleteOilVendorInput!
    $condition: ModeloilVendorConditionInput
  ) {
    deleteOilVendor(input: $input, condition: $condition) {
      id
      vendorCognitoSub
      vendorFirst1
      vendorFirst2
      vendorLast1
      vendorLast2
      vendorEmail1
      vendorEmail2
      vendorPhone1
      vendorPhone2
      vendorAddress1
      vendorAddress2
      vendorAddress3
      vendorCity
      vendorState
      vendorZip
      vendorZip4
      unitCountry
      premiumVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createCurrDegreeDays = /* GraphQL */ `
  mutation CreateCurrDegreeDays(
    $input: CreateCurrDegreeDaysInput!
    $condition: ModelcurrDegreeDaysConditionInput
  ) {
    createCurrDegreeDays(input: $input, condition: $condition) {
      id
      currDate
      currTime
      currTemp
      currFeelsLike
      currDegreeDays
      currFeelsLikeDays
      currHWDegreeDays
      currHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const updateCurrDegreeDays = /* GraphQL */ `
  mutation UpdateCurrDegreeDays(
    $input: UpdateCurrDegreeDaysInput!
    $condition: ModelcurrDegreeDaysConditionInput
  ) {
    updateCurrDegreeDays(input: $input, condition: $condition) {
      id
      currDate
      currTime
      currTemp
      currFeelsLike
      currDegreeDays
      currFeelsLikeDays
      currHWDegreeDays
      currHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const deleteCurrDegreeDays = /* GraphQL */ `
  mutation DeleteCurrDegreeDays(
    $input: DeleteCurrDegreeDaysInput!
    $condition: ModelcurrDegreeDaysConditionInput
  ) {
    deleteCurrDegreeDays(input: $input, condition: $condition) {
      id
      currDate
      currTime
      currTemp
      currFeelsLike
      currDegreeDays
      currFeelsLikeDays
      currHWDegreeDays
      currHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const createHistDegreeDays = /* GraphQL */ `
  mutation CreateHistDegreeDays(
    $input: CreateHistDegreeDaysInput!
    $condition: ModelhistDegreeDaysConditionInput
  ) {
    createHistDegreeDays(input: $input, condition: $condition) {
      id
      histDate
      histLastUpdate
      histAvgTemp
      histAvgFeelsLike
      histAvgDegreeDays
      histAvgFeelsLikeDays
      histAvgHWDegreeDays
      histAvgHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const updateHistDegreeDays = /* GraphQL */ `
  mutation UpdateHistDegreeDays(
    $input: UpdateHistDegreeDaysInput!
    $condition: ModelhistDegreeDaysConditionInput
  ) {
    updateHistDegreeDays(input: $input, condition: $condition) {
      id
      histDate
      histLastUpdate
      histAvgTemp
      histAvgFeelsLike
      histAvgDegreeDays
      histAvgFeelsLikeDays
      histAvgHWDegreeDays
      histAvgHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const deleteHistDegreeDays = /* GraphQL */ `
  mutation DeleteHistDegreeDays(
    $input: DeleteHistDegreeDaysInput!
    $condition: ModelhistDegreeDaysConditionInput
  ) {
    deleteHistDegreeDays(input: $input, condition: $condition) {
      id
      histDate
      histLastUpdate
      histAvgTemp
      histAvgFeelsLike
      histAvgDegreeDays
      histAvgFeelsLikeDays
      histAvgHWDegreeDays
      histAvgHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const createRefills = /* GraphQL */ `
  mutation CreateRefills(
    $input: CreateRefillsInput!
    $condition: ModelrefillsConditionInput
  ) {
    createRefills(input: $input, condition: $condition) {
      id
      heatingUnitID
      refillDate
      fullRefill
      projectedVolume
      actualVolume
      volumeDiff
      accuracyRatio
      refillVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRefills = /* GraphQL */ `
  mutation UpdateRefills(
    $input: UpdateRefillsInput!
    $condition: ModelrefillsConditionInput
  ) {
    updateRefills(input: $input, condition: $condition) {
      id
      heatingUnitID
      refillDate
      fullRefill
      projectedVolume
      actualVolume
      volumeDiff
      accuracyRatio
      refillVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRefills = /* GraphQL */ `
  mutation DeleteRefills(
    $input: DeleteRefillsInput!
    $condition: ModelrefillsConditionInput
  ) {
    deleteRefills(input: $input, condition: $condition) {
      id
      heatingUnitID
      refillDate
      fullRefill
      projectedVolume
      actualVolume
      volumeDiff
      accuracyRatio
      refillVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
